import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { ReadPopup } from '@atlassian/data-classification-level';

type ReadViewProps = {
	name?: string;
	guideline?: string;
	onChangeLevelClick?: () => void;
};

const messages = defineMessages({
	noGuidelines: {
		id: 'data-classification.read-view-popup.no-guidelines',
		defaultMessage: 'No guidelines',
		description:
			'This is the text to be displayed when there is no guideline for classification in read view',
	},
});

export const ClassificationReadViewPopup = ({
	name,
	guideline,
	onChangeLevelClick,
}: ReadViewProps) => {
	const { formatMessage } = useIntl();
	return (
		<ReadPopup
			name={name}
			guideline={guideline || formatMessage(messages.noGuidelines)}
			onChangeLevelClick={onChangeLevelClick}
		/>
	);
};
